import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import {
	SAVED_MARKET_STATE_FILTER_FRAGMENT
} from '@app/model/market_state/_saved_filters/service/SavedMarketStateFilterGraphQLFragments';


export const FIND_MY_SAVED_MARKET_STATE_FILTERS_QUERY: GraphQL = {
	name: 'findMySavedMarketStateFilters',
	gql: gql`
		${SAVED_MARKET_STATE_FILTER_FRAGMENT}
		query findMySavedMarketStateFilters($companyHotelId: Long!) {
			findMySavedMarketStateFilters(companyHotelId: $companyHotelId) {
				...SavedMarketStateFilterFragment
			}
		}
	`
}

export const FIND_DEFAULT_MARKET_STATE_FILTER_QUERY: GraphQL = {
	name: 'findDefaultMarketStateFilter',
	gql: gql`
		${SAVED_MARKET_STATE_FILTER_FRAGMENT}
		query findDefaultMarketStateFilter($companyHotelId: Long!) {
			findDefaultMarketStateFilter(companyHotelId: $companyHotelId) {
				...SavedMarketStateFilterFragment
			}
		}
	`
}

export const COUNT_MY_SAVED_MARKET_STATE_FILTERS_QUERY: GraphQL = {
	name: 'countMySavedMarketStateFilters',
	gql: gql`
		query countMySavedMarketStateFilters($companyHotelId: Long!) {
        countMySavedMarketStateFilters(companyHotelId: $companyHotelId) 
		}
	`
}

export const CREATE_MARKET_STATE_FILTER_MUTATION: GraphQL = {
	name: 'createSavedMarketStateFilter',
	gql: gql`
      ${SAVED_MARKET_STATE_FILTER_FRAGMENT}
		mutation createSavedMarketStateFilter($companyHotelId: Long!, $name: String!, $filter: SavedMarketStateFilterFilterInput!) {
			createSavedMarketStateFilter(companyHotelId: $companyHotelId, name: $name, filter: $filter) {
				...SavedMarketStateFilterFragment
			}
		}
	`
}

export const REMOVE_MARKET_STATE_FILTER_MUTATION: GraphQL = {
	name: 'removeSavedMarketStateFilter',
	gql: gql`
      ${SAVED_MARKET_STATE_FILTER_FRAGMENT}
      mutation removeSavedMarketStateFilter($companyHotelId: Long!, $id: Long!) {
          removeSavedMarketStateFilter(companyHotelId: $companyHotelId, id: $id) {
              ...SavedMarketStateFilterFragment
          }
      }
	`
}

export const MAKE_DEFAULT_MARKET_STATE_FILTER_MUTATION: GraphQL = {
	name: 'makeDefaultMarketStateFilter',
	gql: gql`
      ${SAVED_MARKET_STATE_FILTER_FRAGMENT}
      mutation makeDefaultMarketStateFilter($companyHotelId: Long!, $id: Long!) {
          makeDefaultMarketStateFilter(companyHotelId: $companyHotelId, id: $id) {
              ...SavedMarketStateFilterFragment
          }
      }
	`
}